(() => {
  if (customElements.get('featured-articles')) {
    return;
  }

  class FeaturedArticles extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
    }

    connectedCallback() {

      const swiperContainer = this.querySelector('[data-slider]');
      const swiperOptions = {
        slidesPerView: 1.5,
        loop: false,
        allowTouchMove: true,
        spaceBetween: 24,
        autoHeight: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          600: {
            slidesPerView: 2.2,
            spaceBetween: 24
          },
          990: {
            slidesPerView: 3.2,
            spaceBetween: 48
          }
        }
      };

      this.slider = new Swiper(swiperContainer, swiperOptions);
    }
  }

  customElements.define('featured-articles', FeaturedArticles);
})();
